export default __webpack_public_path__ + "static/media/plan4-col2-img.d3c82c9d.svg";